import { Checkbox } from 'antd'
import React, { useCallback } from 'react'
import { ListChildComponentProps } from 'react-window'
import styled from 'styled-components'
import { BaseSensorEntry } from 'types'

const TagRowContainer = styled.div<{ $selected?: boolean }>`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.5rem;
  cursor: pointer;
  background: ${({ $selected, theme }) =>
    $selected
      ? theme.forecast.hoverGhostButton
      : theme.forecast.cardBackground};

  &:hover {
    background: ${({ $selected, theme }) =>
      $selected
        ? theme.forecast.activeGhostButton
        : theme.forecast.hoverGhostButton};
  }

  &:active {
    background: ${({ $selected, theme }) =>
      $selected
        ? theme.forecast.activeGhostButton
        : theme.forecast.activeGhostButton};
  }
`

const TagRowColumn = styled.div`
  flex: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`

const TagRowName = styled(TagRowColumn)`
  color: ${({ theme }) => theme.forecast.defaultText};
  font-weight: 500;
`

const TagRowDescription = styled(TagRowColumn)`
  color: ${({ theme }) => theme.forecast.secondaryText};
`

interface TagRowData {
  filteredTags: BaseSensorEntry[]
  selectedTags: BaseSensorEntry[]
  onToggleTag?: (tag: BaseSensorEntry) => void
}

export const TagRow: React.FC<ListChildComponentProps<TagRowData>> = ({
  data,
  index,
  style,
}) => {
  const { filteredTags, selectedTags, onToggleTag } = data
  const tag = filteredTags[index]
  const isSelected = tag ? selectedTags.some((t) => t.id === tag.id) : false

  const handleTagToggle = useCallback(() => {
    if (onToggleTag && tag) {
      onToggleTag(tag)
    }
  }, [onToggleTag, tag])

  return (
    <div style={style}>
      {tag && (
        <TagRowContainer $selected={isSelected} onClick={handleTagToggle}>
          <Checkbox checked={isSelected} />
          <TagRowName>{tag.data?.name ?? ''}</TagRowName>
          <TagRowDescription>{tag.data?.description ?? ''}</TagRowDescription>
        </TagRowContainer>
      )}
    </div>
  )
}
